import React, { useEffect, useState } from "react";
import { Wine, ShieldAlert } from "lucide-react";

const STORAGE_KEY = "geovinum_age_v1";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setOpen(true);
    } catch { setOpen(true); }
  }, []);

  if (!open) return null;
  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ adult: true, ts: Date.now() })); } catch {}
    setOpen(false);
  };
  const reject = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div className="fixed inset-0 z-[60] bg-[#1F3A5F]/85 backdrop-blur-sm flex items-center justify-center px-4 overlay-safe pb-safe overflow-y-auto" data-testid="age-gate">
      <div className="max-w-md w-full rounded-3xl bg-white p-7 md:p-9 text-center shadow-2xl">
        <Wine className="w-10 h-10 text-[#E5276A] mx-auto" />
        <h1 className="font-display text-3xl text-[#1F3A5F] mt-4">Avez-vous l'âge légal ?</h1>
        <p className="text-sm text-[#4A5568] mt-3">
          geoVINUM contient des contenus liés aux boissons alcoolisées. Vous devez avoir l'âge légal de consommation d'alcool dans votre pays de résidence pour continuer.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center">
          <button data-testid="age-gate-reject" onClick={reject} className="px-5 py-3 rounded-xl border border-[#1F3A5F]/15 text-[#1F3A5F] font-bold hover:bg-[#FBF7F3]">Non, je n'ai pas l'âge</button>
          <button data-testid="age-gate-accept" onClick={accept} className="px-5 py-3 rounded-xl bg-[#E5276A] text-white font-bold hover:bg-[#C01661]">J'ai l'âge légal</button>
        </div>
        <p className="mt-5 text-[10px] text-[#8B95A1] inline-flex items-center gap-1 justify-center"><ShieldAlert className="w-3 h-3" /> L'abus d'alcool est dangereux pour la santé. À consommer avec modération.</p>
      </div>
    </div>
  );
}
